<template>
  <div>
    <!-- TitleコンポーネントとErrorMessageコンポーネントを読み込み、必要な引数を渡している -->
    <Title title="各種設定" description="パスワードの変更ができます。" />

    <!-- apiからデータを読み込んだらこちらを表示 -->
    <template>
      <!-- 現在の設定の表示-->
      <ConfigAdmin @update="update()"></ConfigAdmin>
    </template>
    <!-- apiからデータを読み込むまではErrorMessageで「データの読み込み中です。」を表示 -->
  </div>
</template>

<script>
//  使いたいコンポーネントを読み込む
import { mapState } from 'vuex'
import Title from '@/components/Title.vue'
import ConfigAdmin from '@/components/ConfigAdmin.vue'

export default {
  name: 'Configs',

  // 使用するコンポーネントを追加
  components: {
    Title,
    ConfigAdmin
  },
  //  関数や加工が必要な表示用テキスト。
  computed: {
    ...mapState({
      isLoggedIn: state => state.auth.isLoggedIn
    })
  }
}
</script>
